export default __webpack_public_path__ + "static/media/iconesMeusDados.abe2ab44.png";